import { ITopbar } from '@/interfaces/topbar.interface'
import ENV from '../../environment.json'

const appEnviroment = String(process.env.VUE_APP_ENVIROMENT).toLowerCase()

const BASE_URL = ENV[appEnviroment]['BASE_URL']

function removeTrailingSlash(url: string): string {
  if (url.endsWith('/')) {
    return url.slice(0, -1)
  }
  return url
}

const settings: ITopbar = {
  showPlusButtonMenu: true,
  showSearchInput: true,
  showSupportCenter: true,
  showLauncher: true,
  showNotificationBell: true,
  baseUrl: removeTrailingSlash(BASE_URL),
  bellKey: 'alegra-web',
  userMenuOptions: {
    consumption: true,
    configuration: true,
    profile: true,
    security: true,
    electronicInvoicingStatus: true,
    statusOfSolutions: true,
  },
}

export default settings
